// Who a charge line's fee belongs to.
//
// THE LIST IS THE CASE'S OWN TEAM, deliberately, and not a search of every
// doctor in the hospital. A bill that can name somebody the operative record
// does not is exactly the reconciliation problem this work exists to close —
// so if a person is missing here, the fix is to put them on the team, which
// they should have been on anyway.
//
// The case's surgeon and anaesthetist are offered whether or not anybody filled
// in the team, because they are on the case itself and a theatre that has not
// completed its roster still has to bill.

import { teamMembers } from "./teamMembers";
import { OT_CHARGE_CATEGORIES } from "../constants";

/**
 * Everyone this case can bill a fee to, each with the role billing means.
 *
 * @param {object|null} otCase
 * @param {{team?: unknown[]}|unknown[]|null} teamPayload
 * @returns {Array<{id: string, name: string, role: string}>}
 */
export function casePractitioners(otCase, teamPayload) {
  const c = otCase || {};
  const rows = [
    c.primary_surgeon_name && {
      id: c.primary_surgeon_id,
      name: c.primary_surgeon_name,
      role: "Primary surgeon",
    },
    c.anaesthetist_name && {
      id: c.anaesthetist_id,
      name: c.anaesthetist_name,
      role: "Anaesthetist",
    },
    ...teamMembers(teamPayload).map((m) => ({
      id: m.member_id,
      name: m.member_name,
      role: m.attendee_type_name || "",
    })),
  ].filter((p) => p && p.name);

  // First mention wins, so the case's own role beats the roster's wording for
  // the same person — "Primary surgeon" is what the bill means.
  const seen = new Set();
  return rows.filter((p) => {
    const key = String(p.id || p.name);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

/** Whether this charge category is a named person's fee. Mirrors the server's
 *  rule, which is on the service type — this only decides what the form shows;
 *  the POST is what enforces it. */
export function practitionerRequiredFor(categoryId) {
  const category = OT_CHARGE_CATEGORIES.find((c) => c.id === categoryId);
  return Boolean(category && category.practitioner);
}
